'use client'
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import 'swiper/css';
import 'swiper/css/pagination';
import MainMenu from '@/components/MainMenu';
import Image from 'next/image'

export default function Page() {
  const { phoneNumber, isCookieLoading } = usePhoneNumber();

  return (
    <main className="flex min-h-screen flex-col items-center justify-between overflow-hidden">
      <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} />
      <section className="text-start pt-10 pb-0 md:py-24 w-screen justify-start bg-gradient-to-b from-gradient-start to-white dark:from-purple-700 dark:to-dark">
        <div className="container md:my-40 my-20">
          <div className="space-y-10">

            <div className='bg-white text-dark-700 w-fit mx-auto p-5 rounded-lg'>
            <div className='text-center '>
            <Image
							src="/images/greatact.png"
							alt="Image 2"
							width={470}
							height={397}
              className='mx-auto'
						/>
            </div>
            <div className="mb-2 mx-auto text-lg max-w-[500px] text-center">
              Грейт Айкт ХХК нь сэтгэц-хэмжил зүйн тест боловсруулалт, нутагшуулалт, сэтгэл зүйн судалгаа болон сургалт-хөтөлбөр боловсруулах чиглэлээр үйл ажиллагаа явуулдаг.
            </div>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </main>
  )
}
